export const root = "r1ah0cgc";
export const bodyContainer = "b1izp3pw";
export const content = "cuv4ik5";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");